import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
const verticalEmbedProviders = {
  event: "event",
  booking: "booking",
  product: "product"
};
const contentTypeMap = {
  EVENT: "Events",
  BOOKING: "Bookings",
  PRODUCT: "Stores",
  UNRECOGNIZED: "Events"
};
const verticalEmbedModals = {
  insertBooking: `${Node_Type.APP_EMBED}.insertBooking`,
  insertProduct: `${Node_Type.APP_EMBED}.insertProduct`,
  insertEvent: `${Node_Type.APP_EMBED}.insertEvent`,
  replace: `${Node_Type.APP_EMBED}.replace`,
  settings: `${Node_Type.APP_EMBED}.settings`,
  presets: `${Node_Type.APP_EMBED}.presets`,
  colorPicker: `${Node_Type.APP_EMBED}.colorPicker`
};
const MAX_TITLE_LENGTH = 80;
const MAX_BUTTON_TEXT_LENGTH = 150;
const MAX_RIBBON_TEXT_LENGTH = 150;
export {
  MAX_BUTTON_TEXT_LENGTH,
  MAX_RIBBON_TEXT_LENGTH,
  MAX_TITLE_LENGTH,
  contentTypeMap,
  verticalEmbedModals,
  verticalEmbedProviders
};
//# sourceMappingURL=constants.js.map
